import React from 'react';
import { Transaction } from '../../../../types/rest/assetCatalogTypes';
import LabIcon from '../../../../components/icons/LabIcon';
import { useDispatch } from 'react-redux';
import { showToastNotification } from '../../../../store/ui/toasts/toastsActions';
import { ToastType } from '../../../../store/ui/toasts/toastsTypes';
import { openSandbox } from '../../../../store/ui/sandboxActions';

interface TransactionSandboxBtnProps {
  transaction: Transaction;
  disabled: boolean;
}

const TransactionSandboxBtn = ({ transaction, disabled }: TransactionSandboxBtnProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (disabled) {
      dispatch(
        showToastNotification(
          ToastType.Info,
          'Transaction not saved',
          'Testing Sandbox is available after transaction is saved',
        ),
      );
      return;
    }
    dispatch(openSandbox(transaction));
  };

  return (
    <button
      id={`qa-tbl-row-sandbox-transaction-${transaction.id}`}
      className="btn btn-link-dark btn-no-hover mr-2"
      style={{ opacity: !disabled ? 1 : 0.6 }}
      title={
        disabled ? 'Testing Sandbox is available after transaction is saved' : 'Test the transaction in sandbox mode'
      }
      onClick={handleClick}
    >
      <LabIcon size={14} />
      <span className="sr-only">Open Transaction in the Sandbox</span>
    </button>
  );
};

export default TransactionSandboxBtn;
